<!-- 预约组件 -->
<template>
  <div class="reservation-container" v-if="signInfo.expert_repoint_channel">
    <div
      class="re-wrapper"
      @click="bindJump"
      v-buried
      :data-buried="'BG_VIP_HD_0YDK_YY_' + (activityId + 1)"
    >
      <img class="image" :src="signInfo.expert_repoint_channel.image" alt="" />
      <div class="time-out-container">
        <span class="time-text">距开始：</span>
        <van-count-down :time="time" @finish="bindTimeFinish" ref="countdown">
          <template #default="timeData">
            <span class="block">{{ timeData.hours | filterNum }}</span>
            <span class="colon">时</span>
            <span class="block">{{ timeData.minutes | filterNum }}</span>
            <span class="colon">分</span>
            <span class="block">{{ timeData.seconds | filterNum }}</span>
            <span class="colon">秒</span>
          </template>
        </van-count-down>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    signInfo: {
      type: Object,
      default: null
    },
    activityId: {
      type: Number,
      default: 2
    }
  },
  components: {},
  data() {
    return {
      time: 0
    }
  },
  filters: {
    filterNum(num) {
      return num > 9 ? num : '0' + num
    },
    filterMilliseconds(num) {
      return Math.floor(num / 100)
    }
  },
  created() {
    this.time = this.getTime()
  },
  methods: {
    getTime() {
      let now = new Date()
      let nowTimes = now.getTime()
      let todayZero = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0,
        0
      )
      let oneDayTimes = 1000 * 60 * 60 * 24
      let repeatTime = oneDayTimes - (nowTimes - todayZero)
      return repeatTime
    },
    bindJump() {
      this.$http.bindH5UMA('CLICK_VIP_HD_0YDK_YY_' + (this.activityId + 1))
      /* setTimeout(() => {
        location.href = this.signInfo.expert_repoint_channel.router;
      }, 200); */
      this.$betterwe.jumpRoute(this.signInfo.expert_repoint_channel.router)
    },
    bindTimeFinish() {
      this.time = this.getTime()
    }
  }
}
</script>
<style lang="scss" scoped>
.reservation-container {
  padding: 0px 14px;
  .re-wrapper {
    min-height: 100px;
    position: relative;
    border-radius: 8px;
    .image {
      width: 100%;
    }
  }
  .time-out-container {
    position: absolute;
    width: 319px;
    padding: 0px 12px;
    box-sizing: border-box;
    bottom: 34px;
    left: 50%;
    transform: translate(-50%, 0%);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: normal;
    font-size: 11px;
    color: #ffffff;
    line-height: 16px;
    .van-count-down {
      display: flex;
      align-items: center;
    }
    .colon {
      display: inline-block;
      margin: 0 5px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #ffffff;
      line-height: 16px;
    }
    .block {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      color: #fff;
      text-align: center;
      font-weight: bold;
      font-size: 12px;
      color: #ffffff;
    }
  }
}
</style>
